// Starting points for a new mindmap. Each is a Markdown outline (the same
// format Import reads), so adding one is just adding text here.
import { outlineToMap } from './io.js';

export const TEMPLATES = [
  { id: 'blank', label: 'Blank', desc: 'One central topic.', layout: 'balanced', md: '# Central idea' },
  { id: 'brainstorm', label: 'Brainstorm', desc: 'A central question with four open branches.', layout: 'balanced', md: `# What are we solving?
- Ideas
- Questions
- Risks
- Next steps` },
  { id: 'practice', label: 'Practice plan', desc: 'One practice, block by block.', layout: 'right', md: `# Practice plan
- Warm-up
  - Skating
  - Puck handling
- Skill stations
  - Station 1
  - Station 2
- Small area games
- Team systems
- Compete drill
- Cool-down and talk
  - [ ] Key message` },
  { id: 'season', label: 'Season plan', desc: 'Phases of a season with goals and focus skills.', layout: 'down', md: `# Season plan
- Pre-season
  - Goals
  - Focus skills
- Early season
  - Goals
  - Focus skills
- Mid-season
  - Goals
  - Focus skills
- Playoffs
  - Goals
  - Focus skills` },
  { id: 'player', label: 'Player development', desc: 'The areas of a player\'s game.', layout: 'balanced', md: `# Player
- Skating
  - Edges
  - Crossovers
  - Transitions
- Puck skills
  - Handling
  - Protection
- Shooting
  - Wrist shot
  - Snap shot
- Hockey sense
  - Reads
  - Support
- Compete
- Off-ice` },
  { id: 'drill', label: 'Drill breakdown', desc: 'Purpose, setup, execution and coaching points.', layout: 'right', md: `# Drill name
- Purpose
- Setup
  - Pucks
  - Cones
- Execution
  - Step 1
  - Step 2
- Coaching points
- Progressions
- Common mistakes` },
  { id: 'bubble', label: 'Bubble map', desc: 'A living graph of ideas: bubbles that push, pull and link, like Obsidian\'s graph.', layout: 'bubble', md: `# Big idea
- Idea
  - Detail
  - Detail
- Idea
  - Detail
- Idea
- Question
- Link`},
  { id: 'meeting', label: 'Meeting notes', desc: 'Agenda, notes, decisions and action items.', layout: 'right', md: `# Meeting
- Agenda
- Notes
- Decisions
- Action items
  - [ ] First action
  - [ ] Second action` },
  { id: 'swot', label: 'SWOT', desc: 'Strengths, weaknesses, opportunities, threats.', layout: 'balanced', md: `# SWOT
- Strengths
- Weaknesses
- Opportunities
- Threats` },
  { id: 'project', label: 'Project plan', desc: 'Goal, milestones and tasks.', layout: 'right', md: `# Project
- Goal
- Milestones
  - Milestone 1
  - Milestone 2
- Tasks
  - [ ] Task 1
  - [ ] Task 2
- Resources
- Risks` },
];

export function fromTemplate(id, opts = {}) {
  const t = TEMPLATES.find((x) => x.id === id) || TEMPLATES[0];
  // a blank map takes the default layout from Settings; a template keeps its own
  const map = outlineToMap(t.md, 'Central idea', { theme: opts.theme, line: opts.line, layout: t.id === 'blank' ? (opts.layout || t.layout) : t.layout });
  if (opts.title) map.root.text = opts.title;
  return map;
}
